import React from 'react';

const ParentIcon = () => {
  return (
    <svg preserveAspectRatio="xMidYMin"  viewBox="0 0 173.26 126.24">
      <g>
        <path fill="#e3e1df" d="M61.87 16.12h68.88v80.95H61.87z"/>
        <path fill="#e3e1df" d="M82.67 23.95h38.2v18.39h-38.2zM82.67 46.13h38.2v18.39h-38.2zM82.67 68.31h38.2V86.7h-38.2z"/>
        <path fill="#fff" stroke="#a7acb5" strokeMiterlimit="10" d="M43.12 30.57v83.48H112V52.72L89.18 30.57H43.12z"/>
        <path fill="#e3e1df" d="M94.2 58.36h8.38v19.8H94.2zM53.53 46.91h21.33v8.04H53.53zM78.67 46.98h23.74v8.04H78.67zM52.7 81.9h49.7v19.89H52.7z"/>
        <path fill="#5acbf9" d="M53.07 39.26h45.68v4.39H53.07z"/>
        <path fill="#fff" stroke="#a7acb5" strokeMiterlimit="10" d="M89.18 30.57L112 52.72H89.18V30.57z"/>
        <path fill="#fff" d="M53.53 58.36h36.91v19.77H53.53z"/>
        <path fill="#5bcacb" d="M53.52 58.36h36.91v19.77H53.52z"/>
        <path fill="#fff" d="M90.44 78.16H53.53V67.4l9.52-3.53 8.93.56 7.49-1.28 6.65.71 4.32-1.45v15.75z"/>
        <path fill="#97ca3f" d="M90.44 78.14H53.53V67.38l9.52-3.54 8.93.57 7.49-1.28 6.65.71 4.32-1.45v15.75z"/>
        <path fill="#ec6330" d="M90.42 78.14h-36.9v-3.97l9.52-3.55 8.93.75 7.49-4.06 6.65 2.36 4.31-3.47v11.94z"/>
        <path fill="none" stroke="#a7acb5" strokeMiterlimit="10" d="M53.53 58.36h36.91v19.77H53.53z"/>
      </g>
    </svg>
  );
}

export default ParentIcon;